import { HOME_PATH } from "@/modules/common/pages/home/home-path";
import Card from "@/shared/data-display/card";
import { Result } from "@/shared/feedback/result";
import Button from "@/shared/form/button";
import { Link } from "react-router-dom";
import { Page } from "../page";
import { useTranslations } from "use-intl";
import { PAGE_404_PATH } from "./page-404-path";

export function Page404() {
  const t = useTranslations("Page404");

  return (
    <Page
      title={t("Page not found")}
      breadcrumbsOptions={{
        path: PAGE_404_PATH,
      }}
    >
      <Card>
        <Result
          status="404"
          title={t("Page not found")}
          extra={
            <Link to={HOME_PATH}>
              <Button type="primary">{t("Go main")}</Button>
            </Link>
          }
        />
      </Card>
    </Page>
  );
}
